import {
    useFetchUserPreference,
    useUserPreference,
} from 'userPreferences/hooks';
import {
    IndexMapping,
    IndexMappingsUserPreferenceKey,
} from './store/IndexMappingsState';

const initialIndexMappings: IndexMapping[] = [];

export const useSelectIndexMappingsUserPreference = () => {
    return useUserPreference<IndexMapping[]>(
        IndexMappingsUserPreferenceKey,
        initialIndexMappings
    );
};

export const useSelectIndexMappingsUserPreferenceWithoutDefaulting = () => {
    return useUserPreference<IndexMapping[]>(IndexMappingsUserPreferenceKey);
};

export const useFetchIndexMappingsUserPreference = () =>
    useFetchUserPreference(
        IndexMappingsUserPreferenceKey,
        initialIndexMappings
    );
